// src/components/Toolbar.js

import React from "react";
import PropTypes from "prop-types";
import IconButtonWithTooltip from 'components/buttons/IconButtonWithTooltip'; 
import 'assets/css/componentStyles/Toolbar.css';

const Toolbar = ({ items }) => {
    return (
        <div className="toolbar">
            {items.map((item, index) => (
                <IconButtonWithTooltip key={index} className="toolbar-icon" translationId={item.translationId} icon={item.icon} onClick={item.onClick} disabled={item.disabled} isLoading={item.isLoading}/>
            ))}
        </div>
    );
};

Toolbar.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            translationId: PropTypes.string,
            icon: PropTypes.object.isRequired,
            onClick: PropTypes.func.isRequired,
            title: PropTypes.string
        })
    ).isRequired
};

export default Toolbar;